<template>
    <v-text-field
        :value="value"
        :label="label"
        solo
        hide-details
        clearable
        @change="notifyChange"
    >
        <v-icon slot="append"> mdi-magnify </v-icon>
    </v-text-field>
</template>

<script>
export default {
    props: {
        value: String,
        label: {
            type: String,
            default: '搜尋',
        },
    },
    methods: {
        notifyChange(e) {
            this.$emit('input', e);
            this.$emit('change', e);
        },
    },
};
</script>

<style>
</style>
